import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

interface CategoryValueChartProps {
  data: Array<{ category: string; value: string; count: number }>;
}

const brl = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

export function CategoryValueChart({ data }: CategoryValueChartProps) {
  const chart = data.map((r) => ({ category: r.category, value: Number(r.value), count: r.count }));
  if (chart.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-900">Valor por categoria</h3>
        <p className="mt-3 text-sm text-gray-500">Sem ativos com valor de aquisição.</p>
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">Valor por categoria (top 10)</h3>
      <div className="mt-3 h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chart} layout="vertical" margin={{ left: 20, right: 20 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" tickFormatter={(v) => brl(v)} fontSize={11} />
            <YAxis type="category" dataKey="category" width={120} fontSize={12} />
            <Tooltip
              formatter={(v: number) => brl(v)}
              labelFormatter={(l) => `Categoria: ${l}`}
            />
            <Bar dataKey="value" fill="#3b82f6" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
